import React from 'react';
import { func } from 'prop-types';
import { Box } from '@styleseat/ui';
import { Pressable } from 'react-native';
import { ChevronIcon } from '../../ui/Icons';

const NavigateBack = ({ onPress }) => (
  <Pressable onPress={onPress} testID="navigateBack">
    <Box
      minWidth={0}
      minHeight={40}
      justifyContent="center"
      alignItems="center"
    >
      <ChevronIcon
        direction="left"
        height={20}
        width={20}
      />
    </Box>
  </Pressable>
);

NavigateBack.propTypes = {
  onPress: func,
};
NavigateBack.defaultProps = {
  onPress: null,
};

export default NavigateBack;
